// CityProse — renders CityContent prose (LLM-written markdown-ish text) as React
// elements: paragraphs, "-"/"1." lists, "#" headings and **bold**. No HTML injection.
import React from 'react';
import { B } from '../constants';

const LIST_RE = /^([-*•]|\d+[.)])\s+/;

function inline(text) {
  const clean = String(text).replace(/\[([^\]]+)\]\([^)]+\)/g, '$1').replace(/`/g, '');
  return clean.split(/(\*\*[^*]+\*\*)/g).filter(Boolean).map((part, i) =>
    /^\*\*[^*]+\*\*$/.test(part)
      ? <strong key={i}>{part.slice(2, -2)}</strong>
      : part.replace(/(^|\s)[*_]+|[*_]+(\s|$)/g, '$1$2'));
}

export function proseBlocks(text) {
  const blocks = [];
  for (const chunk of String(text || '').split(/\n\s*\n/)) {
    const lines = chunk.split('\n').map((l) => l.trim()).filter(Boolean);
    let para = [];
    let list = null;
    const flushPara = () => { if (para.length) blocks.push({ type: 'p', text: para.join(' ') }); para = []; };
    const flushList = () => { if (list) blocks.push(list); list = null; };
    for (const line of lines) {
      if (/^#{1,6}\s/.test(line)) { flushPara(); flushList(); blocks.push({ type: 'h', text: line.replace(/^#+\s*/, '') }); continue; }
      if (LIST_RE.test(line)) {
        flushPara();
        const type = /^\d/.test(line) ? 'ol' : 'ul';
        if (!list || list.type !== type) { flushList(); list = { type, items: [] }; }
        list.items.push(line.replace(LIST_RE, ''));
        continue;
      }
      flushList();
      para.push(line);
    }
    flushPara(); flushList();
  }
  return blocks;
}

export default function CityProse({ text, blocks, style }) {
  const list = blocks || proseBlocks(text);
  if (!list.length) return null;
  const p = { fontFamily: "'Montserrat',sans-serif", fontSize: 15, lineHeight: 1.75, color: B.night, margin: '0 0 12px', ...style };
  return list.map((b, i) => {
    if (b.type === 'h') return <h3 key={i} style={{ ...p, fontWeight: 700, fontSize: 16 }}>{inline(b.text)}</h3>;
    if (b.type === 'p') return <p key={i} style={p}>{inline(b.text)}</p>;
    const Tag = b.type;
    return (
      <Tag key={i} style={{ ...p, paddingLeft: 22 }}>
        {b.items.map((it, j) => <li key={j} style={{ marginBottom: 6 }}>{inline(it)}</li>)}
      </Tag>
    );
  });
}
